var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFluentTaskListSquareAdd20Regular = function SvgFluentTaskListSquareAdd20Regular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4D4D4D",
    strokeWidth: 0.6,
    d: "M5 2a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h3.6a5.5 5.5 0 0 1-.393-1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v3.207q.525.15 1 .393V5a3 3 0 0 0-3-3zm3.354 4.104a.5.5 0 1 0-.708-.708L6.234 6.808l-.397-.362a.5.5 0 0 0-.674.738l.75.685a.5.5 0 0 0 .69-.016zm0 4.292a.5.5 0 0 1 0 .708l-1.75 1.75a.5.5 0 0 1-.691.015l-.75-.685a.5.5 0 0 1 .674-.738l.397.363 1.412-1.413a.5.5 0 0 1 .708 0ZM9.5 6.5A.5.5 0 0 1 10 6h2.5a.5.5 0 0 1 0 1H10a.5.5 0 0 1-.5-.5Zm8.5 7a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V13h-1.5a.5.5 0 0 0 0 1H13v1.5a.5.5 0 0 0 1 0V14h1.5a.5.5 0 0 0 0-1H14z"
  })));
};
export default SvgFluentTaskListSquareAdd20Regular;